import { ChevronRight, CloudUpload } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  styled,
  Typography,
  Zoom,
} from "@mui/material";
import { blue, green, red } from "@mui/material/colors";
import Allocation from "./Allocation";
import { useState } from "react";

function FileUploader(props) {
  const { stageChanger } = props;
  const [employeeColor, setEmployeeColor] = useState('info');
  const [clientColor, setclientColor] = useState('info');

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleSubmit = () => {
    stageChanger(<Allocation stageChanger={stageChanger} />);
  };

  const handleClient=()=>{
   setclientColor('info')
   setEmployeeColor(blue[100])
  }

  const handleEmployee=()=>{
    setEmployeeColor('info')
    setclientColor(blue[100])
  }


  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Stack>
          <form>
            <Box
              mt={3}
              display={"flex"}
              flexDirection={{ xs: "column", sm: "column", md: "row" }}
              columnGap={2}
              rowGap={2}
            >
              <Card sx={{ height: 100, width: 300 }} elevation={3}>
                <CardContent sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    sx={{ borderRadius: 4 }}
                    startIcon={<CloudUpload />}
                  >
                    Cerificate of Incorporation
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => console.log(event.target.files)}
                      multiple={false}
                    />
                  </Button>
                </CardContent>
              </Card>
              <Card sx={{ height: 100, width: 300 }} elevation={3}>
                <CardContent sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    sx={{ borderRadius: 4 }}
                    startIcon={<CloudUpload />}
                  >
                    KRA Pin Certificate
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => console.log(event.target.files)}
                      multiple={false}
                    />
                  </Button>
                </CardContent>
              </Card>
              <Card sx={{ height: 100, width: 300 }} elevation={3}>
                <CardContent sx={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    sx={{ borderRadius: 4 }}
                    startIcon={<CloudUpload />}
                  >
                    Business Permit
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => console.log(event.target.files)}
                      multiple={false}
                    />
                  </Button>
                </CardContent>
              </Card>
            </Box>
            <Box display={"flex"} mt={3}>
              <Button
                variant="contained"
                endIcon={<ChevronRight />}
                onClick={handleSubmit}
                sx={{ borderRadius: 4 }}
              >
                Sumbit and Continue
              </Button>
            </Box>
          </form>
        </Stack>
      </Zoom>
    </>
  );
}

export default FileUploader;
